import { useEffect, useMemo } from "react";
import { useAddApprovals, useEditApprovals, useFetchApprovals, useUpdateApprovals } from "../mutation";
import { useGetSchedule, useGetSchedules } from "../../schedulePlanning";

export const useFetchApproval = ({ stageID, projectId, page = 1 }: { stageID: string, projectId?: string, page?: number }) => {

    const approvals = useFetchApprovals();
    const updateApproval = useUpdateApprovals();
    const addApproval = useAddApprovals();
    const editApproval = useEditApprovals();

    const { removeCache: removeGetSchedules } = useGetSchedules(Number(projectId));
    const { removeCache: removeGetSchedule } = useGetSchedule(Number(stageID));

    const fetch = async (currentPage: number) => {
        if (!stageID || stageID === "null" || stageID === "undefined") return;
        await approvals.mutateAsync({ stageID, page: currentPage, limit: 20 } as any);
    };

    const add = async (payload: { user_id: number; is_decision_gate: boolean; }) => {
        await addApproval.mutateAsync({ stageID, payload });
        await fetch(1); // Fetch page 1 after a new item is created
    };

    const edit = async (id: string, payload: { user_id: number; is_decision_gate: boolean }) => {
        await editApproval.mutateAsync({ stageID, payload, approvalID: id });
        await fetch(page);
    };

    const update = async (approvalID: string, status: "on_hold" | "approved" | "pending", notes: null | string) => {
        const payload = { status, notes };
        await updateApproval.mutateAsync({ stageID, approvalID, payload });
        await fetch(page);
        removeGetSchedules();
        removeGetSchedule();
    };

    useEffect(() => {
        if (stageID && stageID !== "null" && stageID !== "undefined") {
            fetch(page);
        }
    }, [stageID, page]);

    const data = useMemo(
        () => (approvals.isSuccess ? approvals?.data?.data?.rows || [] : []),
        [approvals.isSuccess, approvals?.data?.data?.rows]
    );

    return {
        isUpdating: updateApproval.isPending,
        isAdding: addApproval.isPending,
        isEditing: editApproval.isPending,
        isPending: approvals.isPending,
        data,
        pagination: approvals.isSuccess ? approvals?.data?.data?.pagination : null,
        handleUpdateApproval: update,
        handleAssignApprover: add,
        handleUpdateApprover: edit,
    };

};